const tokenLSName = 'token'

export function getBearerToken() {
  return localStorage.getItem(tokenLSName)
}

function decodeJwtPayload(token) {
  try {
    if (!token || typeof token !== 'string') return null
    const tokenParts = token.split('.')
    if (tokenParts.length < 2) return null

    const payloadBase64Url = tokenParts[1]
    const payloadBase64 = payloadBase64Url.replace(/-/g, '+').replace(/_/g, '/')
    const paddedPayload = payloadBase64 + '='.repeat((4 - (payloadBase64.length % 4)) % 4)
    const decodedPayload = atob(paddedPayload)

    return JSON.parse(decodedPayload)
  } catch {
    return null
  }
}

export function getCurrentUserId() {
  const payload = decodeJwtPayload(getBearerToken())
  if (!payload || typeof payload !== 'object') return null

  return (
    payload.Identity ||
    payload.identity ||
    payload.profileId ||
    payload.ProfileId ||
    payload.appUserId ||
    payload.AppUserId ||
    payload.userId ||
    payload.UserId ||
    payload.sub ||
    payload.sid ||
    payload.nameid ||
    payload.NameIdentifier ||
    payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] ||
    payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'] ||
    null
  )
}

export function setBearerToken(token) {
  if (!token) {
    localStorage.removeItem(tokenLSName)
    return
  }

  localStorage.setItem(tokenLSName, token)
}
